import React, { useState } from 'react';
import BackHeader from './BackHeader';
import { STATIC } from '../staticMode';
import { getSyncCode, adoptSyncCode } from '../utils/cloudSync';

const SIZES = [
  { label: '小', v: 0.85 },
  { label: '中', v: 1.0 },
  { label: '大', v: 1.2 },
  { label: '特大', v: 1.45 },
];

// Ports the phone's SettingsScreen: font size + update check + version.
export default function SettingsScreen({ onBack, fontScale, setFontScale, version, user, logout }) {
  const [busy, setBusy] = useState(false);
  const [status, setStatus] = useState('');

  const checkUpdate = () => {
    setBusy(true); setStatus('更新完成，重新啟動…');
    setTimeout(() => window.location.reload(), 600);   // a reload always fetches the newest bundle
  };

  const fs = fontScale || 1;

  return (
    <div className="settings">
      <BackHeader title="設定" onBack={onBack} />
      <div className="set-scroll">
        <h3 className="set-h">字體大小</h3>
        <div className="set-size-row">
          {SIZES.map((sz) => (
            <button key={sz.label} className={`set-size-btn${Math.abs(fs - sz.v) < 0.01 ? ' on' : ''}`}
              onClick={() => setFontScale(sz.v)}>{sz.label}</button>
          ))}
        </div>
        <p className="set-sample" style={{ fontSize: Math.round(22 * fs), lineHeight: `${Math.round(34 * fs)}px` }}>
          Berah mmteru knkawas
        </p>

        {STATIC && (
          <>
            <h3 className="set-h">同步碼</h3>
            <p className="set-p">你的進度會用這組代碼存到雲端。換新手機時，在這裡輸入它就能拿回全部進度。</p>
            <p className="set-p"><b style={{ fontSize: '1.25em', letterSpacing: '0.18em' }}>{getSyncCode() || '（第一次同步時產生）'}</b></p>
            <button className="set-btn" onClick={async () => {
              const cur = getSyncCode();
              const typed = window.prompt('輸入另一台裝置上的同步碼。'
                + (cur ? `\n\n這台裝置目前的同步碼是 ${cur}，若之後想換回來請先記下。` : ''));
              if (typed == null || !typed.trim()) return;
              const res = await adoptSyncCode(typed);
              if (res === 'bad-code') { alert('這不像同步碼——只能是英文字母和數字。'); return; }
              if (res === 'same') { alert('這台裝置已經在用這組代碼了。'); return; }
              window.location.reload();
            }}>使用另一台裝置的同步碼</button>
          </>
        )}

        <h3 className="set-h">應用程式更新</h3>
        <p className="set-p">下載最新的內容與修正，不需重新安裝。</p>
        <button className="set-btn" onClick={checkUpdate} disabled={busy}>檢查更新</button>
        {status ? <p className="set-status">{status}</p> : null}
        <p className="set-meta">版本 {version}</p>

        {!STATIC && user && (
          <>
            <h3 className="set-h">帳號</h3>
            <p className="set-p">{user.name}</p>
            <button className="set-btn" onClick={logout}>登出</button>
          </>
        )}
      </div>
    </div>
  );
}
